import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Invoices.types'

@Injectable({ providedIn: 'root' })
export class Invoices_invoicing_create_transactionsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { projectId: number, cutOffDate?: string, billingContractId?: number, projectIdsToInclude?: number[], projectIdsToExclude?: number[], billingAggregationStrategyIds?: number[], termId?: number, taxScheduleId?: number, oneInvoicePerShipment?: boolean, oneInvoicePerWarehouse?: boolean, useExistingInvoice?: boolean, instruction?: $types.Invoices.Instruction }): Promise<{ messages?: any[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/functions/invoicing_create_transactions`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

